import "./wdyr";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { AppProviders } from "./providers/AppProviders";
import { ThemeProvider } from "@emotion/react";
import React from "react";
import { createTheme } from "@mui/material";
const createAppTheme = (mode: "light" | "dark") =>
  createTheme({
    direction: "rtl",
    palette: {
      mode,
      primary: {
        main: "#2E73FF",
      },
      secondary: {
        main: "#DAD8FD",
      },
    },
    typography: {
      fontFamily: `"myFirstFont", sans-serif`,
    },
  });

const initialTheme =
  (localStorage.getItem("theme") as "light" | "dark") || "light";
let myTheme = createAppTheme(initialTheme);

window.addEventListener("app-theme-change", (e: Event) => {
  try {
    const detail = (e as CustomEvent).detail;
    const theme = detail?.theme === "dark" ? "dark" : "light";
    myTheme = createAppTheme(theme);
  } catch (err) {}
});
const ThemeController = ({ children }: { children: React.ReactNode }) => {
  const [mode, setMode] = React.useState<"light" | "dark">(
    (localStorage.getItem("theme") as "light" | "dark") || "light"
  );

  React.useEffect(() => {
    const handler = (e: Event) => {
      const detail = (e as CustomEvent).detail;
      const theme = detail?.theme === "dark" ? "dark" : "light";
      setMode(theme);
    };
    window.addEventListener("app-theme-change", handler);
    return () => window.removeEventListener("app-theme-change", handler);
  }, []);

  const theme = React.useMemo(() => createAppTheme(mode), [mode]);
  React.useEffect(() => {
    try {
      if (typeof document !== "undefined") {
        // keep attribute on the root element (html) so global CSS selectors like
        // [data-theme="dark"] in src/index.css apply to poppers/papers that
        // are rendered outside the React root node
        document.documentElement.setAttribute("data-theme", mode);
      }
    } catch (err) {}
  }, [mode]);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <AppProviders>
    <ThemeController>
      <App />
    </ThemeController>
  </AppProviders>
);
